"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _constants = require("./constants");

var PopoverWrapper = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1fr74k30"
})(function (_ref) {
  var popoverPosition = _ref.popoverPosition,
      popoverAlignment = _ref.popoverAlignment,
      buttonPopover = _ref.buttonPopover,
      selectors = _ref.selectors;
  var verticalPositionKey;
  var horizontalPositionKey;
  var horizontalPositionValue;
  var additionalStyles;

  switch (popoverPosition) {
    case _constants.POPOVER_POSITION.TOP:
      verticalPositionKey = 'bottom';
      break;

    default:
      verticalPositionKey = 'top';
  }

  switch (popoverAlignment) {
    case _constants.POPOVER_ALIGNMENT.LEFT:
      horizontalPositionKey = 'left';
      horizontalPositionValue = '0';
      break;

    case _constants.POPOVER_ALIGNMENT.CENTER:
      horizontalPositionKey = 'left';
      horizontalPositionValue = '50%';
      additionalStyles = 'transform: translateX(-50%);';
      break;

    default:
      horizontalPositionKey = 'right';
      horizontalPositionValue = '0';
  }

  return "\n      position: absolute;\n      z-index: ".concat(selectors.zIndex('popover'), ";\n      min-width: min-content; \n      ").concat(verticalPositionKey, ": 100%;\n      ").concat(horizontalPositionKey, ": ").concat(horizontalPositionValue, ";\n      ").concat(buttonPopover ? "padding-".concat(horizontalPositionKey, ": 21px;") : '', "\n      ").concat(additionalStyles ? additionalStyles : '', "\n  ");
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
PopoverWrapper.displayName = 'PopoverWrapper';
var _default = PopoverWrapper;
exports.default = _default;